// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YtKp","right":"styles_right__Ly3I5"};